import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { keycloakService } from "services/authService";

export default function LoginSSO() {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get("sso");
    const path = window.location.href
      .replace(/.*?path=/i, "")
      .replace("&cf=1", "");

    if (id) {
      localStorage.removeItem("ssoSubscription");
      localStorage.setItem("ssoSubscription", id);

      keycloak
        .login({
          redirectUri: window.location.origin + path,
          idpHint: id,
        })
        .then(() => {
          const access_token = keycloak.token;

          keycloakService.defaults.headers[
            "Authorization"
          ] = `Bearer ${access_token}`;
        });
    } else {
      navigate("/auth/login");
    }
  }, [keycloak]);

  return <div>Checking SSO configuration...</div>;
}
